import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ArrowUpRight, InfoIcon } from 'lucide-react';
import { easeOutStrong } from '../../utils/motion';
import { demoUrlFor } from '../../data/demoCenter';
export function ResearchIntro() {
  return <section className="bg-white border-b border-line pt-32 pb-20 lg:pt-44 lg:pb-24" data-id="element-1878" data-mp="39yc00mwft16t">
      <motion.div initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      ease: easeOutStrong
    }} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16" data-id="element-1879" data-mp="3ethj7dygg1r7">
        <div className="lg:col-span-5" data-id="element-1880" data-mp="2r6swmeyi3l49">
          <p className="text-sm font-medium text-teal mb-5" data-id="element-1881" data-mp="2r3nan8l64zcr">Research</p>
          <h1 className="font-heading font-extrabold text-4xl sm:text-5xl lg:text-[3.25rem] text-ink-dark leading-[1.08] tracking-tight" data-id="element-1882" data-mp="2w5cjqiotz2y7">
            Research behind connected knowledge and human development.
          </h1>
        </div>
        <div className="lg:col-span-7 lg:pt-10" data-id="element-1883" data-mp="38knqs5zcgnj">
          <p className="text-2xl text-ink-dark leading-relaxed mb-6" data-id="element-1884" data-mp="379kqukczcxh">
            Explore the methods, questions and studies shaping SyNeural’s
            knowledge systems, assessment models and development programs.
          </p>
          <p className="text-lg text-ink-muted leading-relaxed mb-8" data-id="element-1885" data-mp="c74z1897no1q">
            It begins with two connected questions: How do people develop sound
            judgment? And how can knowledge systems help researchers and
            institutions think more clearly?
          </p>
          <p className="text-lg text-ink-muted leading-relaxed mb-8" data-id="element-1886" data-mp="3bpxiks2ept3q">
            Our work brings together cognitive science, human development,
            semantic knowledge, institutional design, and responsible AI. The
            Semantic Knowledge Platform (SKP) connects ideas across research and
            policy. The Human Capability Framework, including CJI and NCJI,
            explores how judgment can be understood, developed, and reassessed
            over time.
          </p>
          <p className="text-lg text-ink-muted leading-relaxed mb-8" data-id="element-1887" data-mp="vwpgrvtv9stt">
            This is SyNeural’s own research program. If you’re looking for tools
            for your research team, see the{' '}
            <a href="/solutions#scientific-research" className="text-navy font-semibold underline decoration-line underline-offset-4 hover:decoration-navy transition-colors duration-150" data-id="element-1888" data-mp="15nk4l4mrh0hd">
              Scientific Research solution
            </a>
            .
          </p>
          <div className="flex gap-4 bg-surface-muted rounded-lg p-5 mb-8" data-id="element-1889" data-mp="hyis96at556t">
            <InfoIcon size={20} className="text-navy-light shrink-0 mt-0.5" aria-hidden="true" data-id="element-1890" data-mp="mw13528dxuhg" />
            <p className="text-ink-dark leading-relaxed" data-id="element-1891" data-mp="rvdlpas84fe8">
              Work on this page is labeled by status: current studies, planned
              pilots, publication plans and research concepts. No completed
              validation studies are published yet.
            </p>
          </div>
          <div className="flex flex-wrap gap-x-8 gap-y-3" data-id="element-1892" data-mp="3nsl93kih517v">
            <a href="/roadmap" className="inline-flex items-center gap-2 text-navy font-semibold hover:text-navy-light transition-colors duration-150 whitespace-nowrap" data-id="element-1893" data-mp="3ns1otx5cq0qo">
              See where our research is going
              <ArrowRight size={16} aria-hidden="true" data-id="element-1894" data-mp="394qetzotioso" />
            </a>
            <a href={demoUrlFor('research')} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-navy font-semibold hover:text-navy-light transition-colors duration-150 whitespace-nowrap" data-id="element-1895" data-mp="344vmrstb3t61">
              Try the Research workspace
              <ArrowUpRight size={16} aria-hidden="true" data-id="element-1896" data-mp="2q64e4lx7qzpa" />
              <span className="sr-only" data-id="element-1897" data-mp="tcsrifkukn3n">(opens in a new tab)</span>
            </a>
          </div>
        </div>
      </motion.div>
    </section>;
}